import { render, staticRenderFns } from "./ExtraInfo.vue?vue&type=template&id=2c095e36&"
import script from "./ExtraInfo.vue?vue&type=script&lang=js&"
export * from "./ExtraInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports